/* eslint-disable react-hooks/exhaustive-deps */
import '../assets/css/create.css';

import { pdf } from '@react-pdf/renderer';
//import CryptoJS from 'crypto-js';
//import { saveAs } from 'file-saver';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import * as yup from 'yup';

//import { ArtistDataForm } from '../components/ArtistDataForm';
import { CreatePdf } from '../components/Pdf.js';
import { ToastAlert } from '../components/ToastAlert';
import { rightsScope } from '../config/terms';
import { AuthContext } from '../providers/AuthProvider';
import { NftContext } from '../providers/NftProvider';
import { removePinFromIPFS, UpdateMetaInIPFS, UploadArtToIPFS, UploadJSONToIPFS, UploadThumbToIPFS } from '../utils/PinataRequests';
import { resizeFile } from '../utils/resizefile';
import { useDropzone } from "react-dropzone";
import { HARDHAT_NETWORK_NAME } from '../providers/AuthProvider';

import thumbnailVideo from '../assets/thumbnailvideo.png';

const Create = () => {
  const authCtxt = useContext(AuthContext);
  const nftInfos = useContext(NftContext);
  const history = useHistory();

  const [picture, setPicture] = useState(null);
  const [imgData, setImgData] = useState(null);
  const [resultToast, setResultToast] = useState({ display: false, message: '', status: '' });
  const [loader, setLoader] = useState(false);
  const [rights, setRights] = useState([rightsScope.level[0]]);
  const [rightsEn, setRightsEn] = useState([rightsScope.levelEn[0]]);
  //const videoImg = useRef(null);
  const artType = ["image/png", "image/jpeg", "image/jpg", "image/svg+xml", "video/mp4", "video/webm"];
  const [authorWalletAddress, setAuthorWalletAddress] = useState("");
  const [backIsDark, setBackIsDark] = useState(true);


  let agent = false;
  let agentHash = "";
  //let resaleRightsHash = "";
  
  let antixx = false;
  let antixxHash = "";

  // pour les tests !!!!!
  //agent = true;
  //agentHash = "QmehfuGjhbDE55smqNSc36wKYqDHgsr4fkW7SgdZbXj76m";
  //resaleRightsHash = "QmSg6WLcubKrSK83oEVop5vtcuP7qzqG4Rkb3VtJnBN37a";
  
  let hostName = window.location.hostname;
  if(hostName.match("ato-agent")) {
    // for boischaut only
    agent = true;
    //agentHash = "QmcfHNjvpjXLBjEnbj985RvT9zCYkdYS4djBr9V6h7TP6i"; // sans chinois
    //pdf avec la version chinoise
    agentHash = "QmU71P6yVqTNsSXXHCUisWa58rDYq3gAJ2eCkZ9BSsDYSa";
    // resaleRightsHash = "QmSg6WLcubKrSK83oEVop5vtcuP7qzqG4Rkb3VtJnBN37a";
  }

  if(hostName.match("ato-antixx")) {
    antixx = true;
    antixxHash = "QmXZ54zDKcu4kiQhugy5FH9RnB5RDJGgo39tmLmJ8om1ay";
  }

  const initialCopies = {
    unique: false,
    numbered: false,
    limited: false,
  };
  const initialNft = {
    artworkName: '',
    symbol: '',
    artistName: '',
    artistEmail: '',
    artistDatas: {},
    date: '',
    rightsDuration: '70',
    price: '',
    copy: initialCopies,
    rightAdapt: false,
    addLogo: false,
    merchandising: false,
    supplyNumber: null,
    supplyNumbered: 0,
    supplyLimited: 0,
    noReissue: false,
    resale: false,
    resaleValue: '1',
    description: '',
    size: '',
    address: '',
    originalHash: '',
    network: HARDHAT_NETWORK_NAME,
  };

  const [protectionLevel, setProtectionLevel] = useState("1");
  const [resaleRights, setResaleRights] = useState("1");
  let resaleRightsValue = "1";

  const AuthorWalletAddress = (e) => {
    // check e.target.value
    setAuthorWalletAddress(e.target.value);
    SetFormError({ ...formError, authorWallet: false });
  }

  /**
  * Create Attributes Metadatas
  * @param {String} protectionLevel
  * @param {String} resaleRights
  * @returns
  */
  const createAttributes = (protectionLevel, resaleRights, IP_rights) => {
    resaleRightsValue = resaleRights;

    if (agent) {
      resaleRightsValue = "10";
      setResaleRights("10");
    } else {
      if (resaleRights === "0" && nft.resale) {
        resaleRightsValue = "1";
        setResaleRights("1") 
      };
    }
    if (antixx) {
      resaleRightsValue = "0";
      setResaleRights("0");
      nft.resale = false;
    }

    //nft.rightAdapt, nft.addLogo, nft.merchandising
    let protectionLevelText = "Private use";
    if (protectionLevel === '2') {
      protectionLevelText = "Public use limited to resale";
    }
    if (protectionLevel === '3') {
      protectionLevelText = "Public use for all purposes";
      if (nft.rightAdapt) {
        protectionLevelText += " + Right to adapt";
      }
      if (nft.addLogo) {
        protectionLevelText += " + Right to add a logo";
      }
      if (nft.merchandising) {
        protectionLevelText += " + Merchandising rights";
      }
    }
    let res = [
      {
        'trait_type': 'Minted on',
        'value': 'Āto'
      },
      {
        'trait_type': 'License type',
        'value': protectionLevelText
      },
      {
        'trait_type': 'Resale rights (%)',
        'value': `${resaleRightsValue}`
      },
      {
        'trait_type': 'View licence',
        'value': `https://ipfs.io/ipfs/${IP_rights}`
        /* 'value': `https://${IP_rights}.ipfs.dweb.link` */
        /* 'value': `nftInfos.generateUrl(${IP_rights})` */
        /* 'value': `ipfs://${IP_rights}` */
      },
    ];

    if (agent) {
      res.push({ 'trait_type': 'Original file SHA384 hash', 'value': nft.originalHash });
      // res.push({ 'trait_type': 'resale_rights_legal_notice', 'value': 'https://ipfs.io/ipfs/' + resaleRightsHash });
    }

    return res;
  };

  const [nft, setNft] = useState(initialNft);
  if(agent) {
    nft.exclusive = true;
    nft.copy.unique = true;
    nft.supplyNumber = 1;
    nft.resale = true;
  }

  if(antixx) {
    nft.artistEmail = "contact@antixx.net";
    nft.exclusive = true;
    nft.copy.unique = true;
    nft.supplyNumber = 1;
    nft.resale = false;
    //setResaleRights("0") ;
  }

  const [formError, SetFormError] = useState({ ...initialNft, artistDatas: false });
  //const [toComplete, setToComplete] = useState(true);
  let schema = yup.object().shape({
    artworkName: yup.string().required('artworkName is required'),
    //symbol: yup.string().required().min(3).max(6),
    symbol: yup.string().min(3).max(6).required('symbol is required'),
    artistName: yup.string().required('artistName is required'),
    artistEmail: yup.string().email().nullable(),
    date: yup.date().required('date is required'),
    copy: yup.object().shape({
      unique: yup.boolean().required('This field must be checked'),
      numbered: yup.boolean().required('This field must be checked'),
      limited: yup.boolean().required('This field must be checked'),
    }),
    supplyNumber: yup.number().required('supplyNumber is required'),
    supplyNumbered: yup.number().nullable(),
    supplyLimited: yup.number().nullable(),
    exclusive: nft.copy.unique ? yup.boolean().required() : yup.boolean().nullable(),
    noReissue: yup.boolean().required('noReissue is required'),
    resale: yup.boolean().required('resale is required'),
    rightAdapt: yup.boolean().nullable(),
    addLogo: yup.boolean().nullable(),
    merchandising: yup.boolean().nullable(),
    description: yup.string().required('description is required'),
    size: yup.string().required('size is required'),
    address: yup.string().required('address is required'),
    originalHash: yup.string().nullable(),
  });

  // Add wallet current account address to artwork
  useEffect(() => {
    if (authCtxt.selectedAddress) {
      setNft({ ...nft, address: authCtxt.selectedAddress });
    }
  }, [authCtxt.selectedAddress]);

  // Change "to complete" badge to "completed"
/*   useEffect(() => {
    if (!toComplete) {
      SetFormError({ ...formError, artistDatas: false });
    }
  }, [toComplete]); */

  /**
   * Handle errors on submit
   * @param {Object} e
   */
  const handleErrorsAtSubmit = async (e) => {
    e.preventDefault();
    // check pic
    if (!picture) {
      SetFormError({ ...formError, pic: true });
      return;
    }
    if (agent || antixx) {
      if (authorWalletAddress.length !== 42 || authorWalletAddress[0] !== '0' || authorWalletAddress[1] !== 'x') {
        SetFormError({ ...formError, authorWallet: true });
        return;
      }
    }
    // check form validity
    nft.date = new Date().toISOString().split('T')[0];
    //console.log("schema: ", schema);
    //console.log('nft :', nft);
    schema
      .validate(nft, { abortEarly: false })
      .then(() => handleSubmit())
      .catch(function (errors) {
        if (errors) {
          console.error(errors.inner);
          //console.error(errors.errors);
          errors?.inner?.forEach((err) => {
            SetFormError((prevForm) => ({ ...prevForm, [err.path]: true }));
          });
        }
      });
    /* if (toComplete) {
      SetFormError((prevForm) => ({ ...prevForm, artistDatas: true }));
    } else {
      return;
    } */

    // check number
    if (checkSupplyNumberError(nft.supplyNumber)) {
      return;
    }
  };

  /**
   * Fill artistDatas nft attribute with datas from child comp
   * @param {Object} datas
   */
  /* const getBackArtistDatas = (datas) => {
    setNft({ ...nft, artistDatas: datas });
  }; */

  /**
   * create image thumbnail
   * @param file
   */
   const makeThumbnail = async (picture) => {
    const picInfos = {
      picName: picture.name.substring(0,picture.name.lastIndexOf(".")),
      picType: picture.name.substring(picture.name.indexOf('.') + 1),
    };
    //console.log('picInfos :', picInfos);

    let thumbnailBlob;
    let thumbnail;
    console.log('picture.type: ', picture.type);
    if (picture.type.match("image")) {
      console.log('avant resize: ', picture);
      if (!picture.type.match("svg")) {
        thumbnailBlob = await resizeFile(picture);
        thumbnail = new File([thumbnailBlob], `${picInfos.picName}_thumbnail.${picInfos.picType}`, { type: picture.type });
      } else {
        thumbnail = picture;
      }
    } else {
      console.log('video avant resize: ', thumbnailVideo);
      //thumbnailBlob = await resizeFile(picture);
      //console.log('après resize');
      //thumbnail = new File([thumbnailBlob], `${picInfos.picName}_thumbnail.${"png"}`, { type: "png" });
      thumbnail = picture; //thumbnailVideo;

      //console.log("size" + picture.size);
      nft.size = `${picture.size} Bytes`;
      console.log('nft :', nft);
    }
    
    console.log('fin thumbnail');
    return thumbnail;
   }

  /**
   * Upload art and associate documents to IPFS, deploy contract and put it on the market
   * @param {Object} e
   */
  const handleSubmit = async () => {
    console.log('nft :', nft);
    setLoader(true);

    const picInfos = {
      picName: picture.name.substring(0,picture.name.lastIndexOf(".")),
      picType: picture.name.substring(picture.name.indexOf('.') + 1),
    };

    //console.log('picInfos :', picInfos);

    //const thumbnail = makeThumbnail(picture);
    let thumbnail;
    await makeThumbnail(picture).then((value) => { thumbnail = value; });

    //console.log('fin thumbnail');
    //console.log('thumbnail :', thumbnail);
    //return;

    // Init every hash
    let art = { thumbnailHash: '', artHash: '', pdfHash: '', JSONhash: '' };

    try {

      setResultToast({ display: true, message: 'Sending data to Pinata cloud, please wait...', status: 'in progress' });

      // upload thumbnail and get url
      const thumbnailResult = await UploadThumbToIPFS(nft, thumbnail);

      //upload Artwork with metadatas and thumbnail url
      art.thumbnailHash = thumbnailResult.data.IpfsHash;
      
      const artResult = await UploadArtToIPFS(nft, picture, art.thumbnailHash);

      art.artHash = artResult.data.IpfsHash;

      //check if Art hash is not already on market
      // if (nftInfos.nfts.some((nft) => nft.id === art.artHash)) {
      //   setResultToast({ display: true, message: 'Whoops...it seems that this picture is already on the market.', status: 'canceled' });
      //   setTimeout(() => setResultToast({ display: false, message: '', status: '' }), 3000);
      //   setLoader(false);
      //   return;
      // }
      // deploy contract and get url
      //const artUrl = `https://${art.artHash}.ipfs.dweb.link`;
      //nftInfos.generateUrl();
      const artUrl = `https://ipfs.io/ipfs/${art.artHash}`;
      const artType = picInfos.picType;
/*
      //const AtoAddress = await nftInfos.deployContract(nft.symbol, nft.artworkName);
      const AtoAddress = "ATOContractAddress";

      //set contract adress in pinatas metadatas
      //await UpdateMetaInIPFS(art.artHash, AtoAddress);
*/
      let AtoAddress = "ATOContractAddress";
      let originalPDFHash = "";
      let artistPDF = false;

      setResultToast({ display: true, message: 'Creating Terms and Conditions, please wait...', status: 'in progress' });
      if (!agent && !antixx) {
        // generate Original PDF
        /*
        artistPDF = true;
        const blobToDownload = await pdf(CreatePdf({ artistPDF, nft, AtoAddress, rights, rightsEn, artUrl, artType, nftInfos })).toBlob();
        // generate original PDF hash
        originalPDFHash = await generateHash(blobToDownload);
        */

        // generate obfuscated pdf for galerie
        artistPDF = false;
        const blob = await pdf(CreatePdf({ artistPDF, nft, AtoAddress, rights, rightsEn, artUrl, artType, nftInfos })).toBlob();
        const artPdf = new File([blob], `${picInfos.picName}_rights.pdf`, { type: 'application/pdf' });
        nftInfos.setPdf(artPdf);
        // upload pdf and get url
        const pdfResult = await UploadArtToIPFS(nft, artPdf, '');
        art.pdfHash = pdfResult.data.IpfsHash;
      } else {
        //https://ipfs.io/ipfs/QmcfHNjvpjXLBjEnbj985RvT9zCYkdYS4djBr9V6h7TP6i
        art.pdfHash = (agent? agentHash: antixxHash);
        originalPDFHash = (agent? agentHash: antixxHash);
      }

      const currentAttributes = createAttributes(protectionLevel, resaleRights, art.pdfHash);
      // create metadatas json
      let metadatas;
      if (picture.type.match("video")) {
        metadatas = createJson(art.artHash, art.pdfHash, `video/${artType}`, originalPDFHash, art.thumbnailHash, art.artHash);
      } else {
        metadatas = createJson(art.artHash, art.pdfHash, artType, originalPDFHash, art.thumbnailHash, art.artHash);
      }
      metadatas.attributes = currentAttributes;
      //upload metadatas json and get url
      const metaResult = await UploadJSONToIPFS(metadatas);

      // Set metadatas to Ato Contracts
      art.JSONhash = metaResult.data.IpfsHash;
      //const metadatasUrl = `https://${art.JSONhash}.ipfs.dweb.link`;
      //const metadatasUrl = `https://ipfs.io/ipfs/${art.JSONhash}`;
      const metadatasUrl = nftInfos.generateUrl(art.JSONhash);
      //await nftInfos.setMetadatas(AtoAddress, metadatasUrl);
      //const AtoAddress = await nftInfos.deployContract(nft.symbol, nft.artworkName);
      let mintNumber = nft.supplyNumber;
      // check whitelist
      if (mintNumber > 50) {
        mintNumber = 50;
      }

      let royalties = 0;
      if (nft.resale){
        royalties = resaleRightsValue * 100;
      }
      
      setResultToast({ display: false, message: '', status: '' });
      // authorWalletAddress
      AtoAddress = await nftInfos.deployContract(nft.artworkName, nft.symbol, metadatasUrl, nft.supplyNumber, mintNumber, royalties, (agent || antixx ? authorWalletAddress : "0x0000000000000000000000000000000000000000"));
      console.log("create.js ato contract address: " + AtoAddress);

      //set contract adress in pinatas metadatas
      await UpdateMetaInIPFS(art.artHash, AtoAddress);
      //await nftInfos.suggestTokenAddition(AtoAddress);
      await nftInfos.suggestTokenAddition(AtoAddress, nft.symbol, 0, metadatas.thumbnailUrl);

      // Sell on the market
      //await nftInfos.sell(AtoAddress, nft.price, nft.supplyNumber);

      // Success
      //saveAs(blobToDownload, `GCS_for_${nft.artworkName}`);
      setLoader(false);
      setResultToast({ display: false, message: '', status: '' });
      setNft(initialNft);
      setImgData(null);
      history.push('/');
    } catch (error) {
        console.error(`${error.message} ${error.error}`);
        // Unpin documents from IPFS if process fail
        for (let key of Object.keys(art)) {
          if (art[key]) {
            try {
              await removePinFromIPFS(art[key]);
            } catch (e) {
              console.error(`${error.message} ${error.error}`);
            }
          }
        }
        setLoader(false);
        setResultToast({ display: true, message: 'Whoops...a problem occured, please try again.', status: 'canceled' });
        setTimeout(() => setResultToast({ display: false, message: '', status: '' }), 3000);
    }
  };

  /**
   * Check if supply number and copies are coherents
   */
  const checkSupplyNumberError = (supplyNumber) => {
    if (nft.copy.unique && supplyNumber !== 1) {
      SetFormError({ ...formError, supplyNumber: true });
      return true;
    }
    if (nft.copy.numbered && (supplyNumber < 2 || supplyNumber > 30)) {
      SetFormError({ ...formError, supplyNumber: true });
      return true;
    }
    if (nft.copy.limited && (supplyNumber < 31 || supplyNumber > 150)) {
      SetFormError({ ...formError, supplyNumber: true });
      return true;
    }
  };

  /*
  const generateHash = async (blob) => {
    blob.name = `GCS_for_${nft.artworkName}`;
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(blob);

      reader.onload = function () {
        const file_result = this.result; // this == reader, get the loaded file "result"
        const file_wordArr = CryptoJS.lib.WordArray.create(file_result); //convert blob to WordArray
        const sha256_hash = CryptoJS.SHA256(file_wordArr); //calculate SHA hash
        const hash = sha256_hash.toString(); //output result
        resolve(hash);
      };
    });
  };
  */

  /**
   * Handle drag/drop picture
   */
   const onDrop = (e) => {
    changePicture(e[0]);
  }

  const { getRootProps } = useDropzone({
    onDrop
  });

  /**
   * Handle preview picture
   */
   const onChangePicture = (e) => {
    changePicture(e.target.files[0])
  }

  /**
   * Handle preview picture
   */
   const changePicture = (file) => {
    if (file) {
      const pic = file;
      if (artType.indexOf(pic.type) === -1) {
        alert('Invalid format, supported: ' + artType);
        return;
      }
      if (pic.size >= 40000000) {
        alert('Invalid size, max = 40MB');
        return;
      }
      //console.log("pic Type: " + typePict);
      setPicture(pic);
      SetFormError({ ...formError, pic: false });
      if (pic.type.match("video/")) {
        console.log("picture: ", pic);
        console.log("name: " + pic.name);
        setNft({ ...nft, size: `${pic.size} Bytes` });
        return;
      }
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setImgData(reader.result);
      });
      reader.readAsDataURL(pic);
      //const thumbnail = makeThumbnail(pic);
    }
  };

  /**
   * Get Image real dimensions
   */
  const onImgLoad = ({ target: img }) => {    
    setNft({ ...nft, size: `${img.naturalWidth} by ${img.naturalHeight} pixels` });  
  };

  /**
   * Define rights level
   * @param {number} level
   */
  const handleRightsLevel = (level) => {
    let rightsList = [];
    let rightsListEn = [];
    //console.log("level :" + level);
    for (let i = 0; i < level; i++) {
      rightsList.push(rightsScope.level[i]);
      rightsListEn.push(rightsScope.levelEn[i]);
    }
    setProtectionLevel(level);
    setRights(rightsList);
    setRightsEn(rightsListEn)
  };

  /**
   * Create Smart Contract Metadatas JSON
   * @param {String} artHash
   * @param {String} pdfHash
   * @param {String} picType
   * @returns
   */
  const createJson = (artHash, pdfHash, picType, originalPDFHash, thumbnailHash, ipfs_pin_hash) => {
    let addDescription = '';
    if (agent || antixx) {
      // addDescription += '\n\nResale notice: https://ipfs.io/ipfs/' + resaleRightsHash + '\n';
      addDescription += `Terms and license: https://ipfs.io/ipfs/${pdfHash}`;
      //addDesciption += 'Metadata :'; `https://ipfs.io/ipfs/${IP_rights}`
    }
    // Resale notice:
    // Terms and license:
    // Metadata :
    // legal
    return {
      name: nft.artworkName,
      author: nft.artistName,
      description: nft.description + addDescription,
      size: nft.size,
      media_format: picType,
      //nftInfos.generateUrl()
      image: `https://ipfs.io/ipfs/${artHash}`,
      IP_license: `https://ipfs.io/ipfs/${pdfHash}`,
      //original_PDF_Hash: originalPDFHash,
      thumbnailUrl: `https://ipfs.io/ipfs/${thumbnailHash}`,
      ipfs_hash: ipfs_pin_hash
      //original_artwork_hash: nft.originalHash
    };
  };

  /**
   * set nft key, reinit formError key to false
   * @param {string} value
   * @param {Object} e
   */
  const handleChange = (value, e) => {
    SetFormError({ ...formError, [value]: false });
    if (value === 'symbol') {
      setNft({ ...nft, [value]: e.target.value.toUpperCase() });
    } else {
      setNft({ ...nft, [value]: e.target.value });
    }
  };

  if (!authCtxt.selectedAddress) {
    history.replace('login');
  }
  try {
    authCtxt._checkUserConnection();
  } catch (e) {
    history.replace('login');
  }

  return (
    <>
      {resultToast.display && <ToastAlert content={resultToast} />}
      <div className="container">
        <form onSubmit={handleErrorsAtSubmit} className="formCreate">
          <div className="row justify-content-center preview-infos">
            {/* ------ Picture ------ */}
            <div className="col col-12 col-md-5">
              <div className={ backIsDark === true ? "mt-3 card create bg-primary border-light shadow-inset preview" : "mt-3 card create bg-secondary border-light shadow-inset preview" } {...getRootProps()}>

                {/* 
                  <video controls style={{width: '100%', height: 'auto'}}>
                    <source id="videoSource" src={picture.name} type={picture.type} />
                  </video>
                */}

                { picture !== null && picture.type.match("video/") ? (
                  <span className="text-center mt-4">The video file:<b> {picture.name} </b>was successfully uploaded.</span>
                ) : (
                  <img onLoad={onImgLoad} src={imgData} className="previewpic rounded m-2 " alt={imgData ? 'preview' : ''} onDrop={onDrop} />
                )}

                {formError.pic && <p className="text-center error">Please choose an image to upload </p>}
              </div>
              <div className="text-center">
                <p className="h6 icon-tertiary medium">
                  <span className="fas fa-medal mr-2">preview background color: </span>
                    {/* className="custom-control-input" */}
                  <input
                    type="checkbox"
                    id="customSwitch2"
                    checked={backIsDark}
                    onChange={(event) => {
                      setBackIsDark(!backIsDark);
                    }}
                  />
                  <span className="ml-2">{backIsDark === true ? 'Black' : 'white'}</span>

                  {/* <img src={thumbnailvideo} alt="" ref={videoImg} style={{display: 'none'}} /> */}
                </p>
              </div>
            </div>
            <div className="col-sm-12 col-md-7">
              <div className="col mt-3">
                <div className="row justify-content-center">
                  <div className="col">
                    <div className="custom-file">
                      <input type="file" accept={artType} className="custom-file-input" id="customFile" onChange={onChangePicture} />
                      <label className="custom-file-label" htmlFor="customFile">
                        { picture !== null && picture.name !== "" ? picture.name : "Choose file" }
                      </label>
                    </div>
                  </div>
                </div>
                {/* ------ Original artwork hash ------ */}
                {agent && (
                <div className="row mb-2">
                  <div className="col">
                    <div className="form-floating">
                      <input
                        className="form-control nftInput"
                        id="floatingOriginalHash"
                        placeholder="Original artwork hash"
                        value={nft.originalHash}
                        aria-describedby="originalHash"
                        onChange={(e) => {
                          handleChange('originalHash', e);
                        }}
                      />
                      <label htmlFor="floatingOriginalHash">Original artwork hash</label>
                    </div>
                  </div>
                </div>
                )}

                <div className="row ">
                  {/* ------ Artwork Name ------ */}
                  <div className="col">
                    <div className="form-floating">
                      <input
                        className="form-control nftInput"
                        id="floatingArtworkName"
                        placeholder="Name of your art work"
                        value={nft.artworkName}
                        aria-describedby="artworkName"
                        onChange={(e) => {
                          handleChange('artworkName', e);
                        }}
                      />
                      <label htmlFor="floatingArtworkName">{antixx ? "Object name":"Artwork name"}</label>
                      {formError.artworkName && <p className="text-center error">An artwork name is required </p>}
                    </div>
                  </div>

                  {/* ------ Artwork Symbol ------ */}
                  <div className="col">
                    <div className="form-floating">
                      <input
                        data-toggle="tooltip"
                        data-placement="top"
                        title="3 to 6 characters"
                        className="form-control nftInput"
                        id="floatingSymbol"
                        placeholder="Symbol"
                        value={nft.symbol}
                        aria-describedby="symbol"
                        onChange={(e) => {
                          handleChange('symbol', e);
                        }}
                      />
                      <label htmlFor="floatingSymbol">Symbol</label>
                      {formError.symbol && <p className="text-center error">A valid symbol is required (3 to 6 characters) </p>}
                    </div>
                  </div>

                  {/* ------ Artwork completion date ------ */}
                  {/* <div className="col">
                    <div className="form-floating">
                      <input
                        className="form-control nftInput"
                        id="completiondate"
                        placeholder="Completion date "
                        value={nft.date}
                        aria-describedby="artworkDate"
                        type="date"
                        max={new Date().toISOString().split('T')[0]}
                        onChange={(e) => handleChange('date', e)}
                      />
                      <label htmlFor="completiondate">Completion date</label>
                      {formError.date && <p className="text-center error">An artwork completion date is required </p>}
                    </div>
                  </div> */}
                </div>
                <div className="row mb-2 mt-2">
                  {/* ------ Artist Name ------ */}
                  <div className="col">
                    <div className="form-floating">
                      <input
                        className="form-control nftInput"
                        id="floatingArtistName"
                        placeholder="Artist name"
                        value={nft.artistName}
                        aria-describedby="artistName"
                        onChange={(e) => handleChange('artistName', e)}
                      />
                      <label htmlFor="floatingArtistName">{antixx ? "Author":"Artist name"}</label>
                      {formError.artistName && <p className="text-center error">An artist name is required </p>}
                    </div>
                  </div>

                  {/* ------ Artist Email ------ */}
                  <div className="col">
                    <div className="form-floating">
                      <input
                        className="form-control nftInput"
                        id="floatingArtistEmail"
                        placeholder="example@example.com"
                        value={nft.artistEmail}
                        aria-describedby="artistEmail"
                        onChange={(e) => handleChange('artistEmail', e)}
                      />
                      <label htmlFor="floatingArtistName">Contact email (optionnal)</label>
                      {/*{formError.artistEmail && <p className="text-center error">A valid email is required </p>}*/}
                    </div>
                  </div>
                </div>

                {/* ------ Author's wallet address ------ */}
                {(agent || antixx) && (
                <div className="row mb-2">
                  <div className="col">
                    <div className="form-floating">
                      <input
                        className="form-control nftInput"
                        id="AuthorWalletAddress"
                        placeholder="Author's wallet address"
                        minLength="42"
                        maxLength="42"
                        aria-describedby="AuthorWalletAddress"
                        onChange={(e) => {
                          AuthorWalletAddress(e);
                        }}
                      />
                      <label htmlFor="floatingOriginalHash">{agent ? (`Author's wallet address`) : (`Antique dealer's address`)} </label>
                      {formError.authorWallet && <p className="text-center error">{agent ? (`Please enter a valid Author's wallet address`) : (`Please enter a valid Antique dealer's address`)} </p>}
                    </div>
                  </div>
                </div>
                )}

{/*                 <div className="accordion nftInput mt-4" id="accordionExample">
                  <div className="accordion-item ">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Personal information (only visible by you)
                        {toComplete ? (
                          <span className="badge bg-warning text-dark ml-3">to complete</span>
                        ) : (
                          <span className="badge bg-success text-dark ml-3">completed</span>
                        )}
                      </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        <ArtistDataForm setToComplete={setToComplete} sendArtistDatas={getBackArtistDatas} isWhitelisted={nftInfos.isWhitelisted} />
                      </div>
                    </div>
                  </div>
                </div>
                {formError.artistDatas && <p className="text-center error">Please complete your personal datas</p>} */}

                {/* ------ Rights level ------  */}
                {!agent && !antixx && (
                <div className="nftInput mt-3">
                  <legend className="h6"> Rights Level</legend>
                  <input
                    type="range"
                    className=" custom-slider"
                    list="tickmarks"
                    id="rights"
                    name="rights"
                    min="1"
                    max="3"
                    step="1"
                    defaultValue="1"
                    onChange={(e) => handleRightsLevel(e.target.value)}
                  />
                  <datalist id="tickmarks">
                    <option value="1" label="1" />
                    <option value="2" label="2" />
                    <option value="3" label="3" />
                  </datalist>
                </div>
                )}
                {!agent && !antixx && rightsEn.map((right, i) => (
                  <p className="terms" key={i}>
                    {right}
                  </p>
                ))}

                {/* ------ right to adapt ------  */}
                {(protectionLevel === '3') && (
                <div className="row">
                  <div className="col">
                  <fieldset className="nftInput row">
                    <div className="col-3">
                      <legend className="h6">Right to adapt</legend>
                    </div>
                    <div className="col-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="artworkAdapt"
                          value={nft.rightAdapt}
                          id="artworkAdaptYes"
                          onChange={(e) => {
                            setNft({ ...nft, rightAdapt: true });
                            SetFormError({ ...formError, rightAdapt: false });
                          }}
                        />
                        <label className="form-check-label" htmlFor="artworkAdaptYes">
                          Yes
                        </label>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="artworkAdapt"
                          id="artworkAdaptNo"
                          value={nft.rightAdapt}
                          onChange={(e) => {
                            setNft({ ...nft, rightAdapt: false });
                            SetFormError({ ...formError, rightAdapt: false });
                          }}
                        />
                        <label className="form-check-label" htmlFor="artworkAdaptNo">
                          No
                        </label>
                      </div>
                    </div>
                    {formError.rightAdapt && <p className="text-center error">Please choose a right adapt </p>}
                    </fieldset>
                  </div>
                </div>
                )}

                {/* ------ right to add a logo ------  */}
                {(protectionLevel === '3') && (
                <div className="row">
                  <div className="col">
                  <fieldset className="nftInput row">
                    <div className="col-3">
                      <legend className="h6">Right to add a logo</legend>
                    </div>
                    <div className="col-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="artworkLogo"
                          value={nft.addLogo}
                          id="artworkLogoYes"
                          onChange={(e) => {
                            setNft({ ...nft, addLogo: true });
                            SetFormError({ ...formError, addLogo: false });
                          }}
                        />
                        <label className="form-check-label" htmlFor="artworkLogoYes">
                          Yes
                        </label>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="artworkLogo"
                          id="artworkLogoNo"
                          value={nft.addLogo}
                          onChange={(e) => {
                            setNft({ ...nft, addLogo: false });
                            SetFormError({ ...formError, addLogo: false });
                          }}
                        />
                        <label className="form-check-label" htmlFor="artworkLogoNo">
                          No
                        </label>
                      </div>
                    </div>
                    {formError.addLogo && <p className="text-center error">Please choose a logo </p>}
                    </fieldset>
                  </div>
                </div>
                )}

                {/* ------ merchandising rights ------  */}
                {(protectionLevel === '3') && (
                <div className="row">
                  <div className="col">
                  <fieldset className="nftInput row">
                    <div className="col-3">
                      <legend className="h6">Merchandising rights</legend>
                    </div>
                    <div className="col-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="artworkMerchandising"
                          value={nft.merchandising}
                          id="artworkMerchandisingYes"
                          onChange={(e) => {
                            setNft({ ...nft, merchandising: true });
                            SetFormError({ ...formError, merchandising: false });
                          }}
                        />
                        <label className="form-check-label" htmlFor="artworkMerchandisingYes">
                          Yes
                        </label>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="artworkMerchandising"
                          id="artworkMerchandisingNo"
                          value={nft.merchandising}
                          onChange={(e) => {
                            setNft({ ...nft, merchandising: false });
                            SetFormError({ ...formError, merchandising: false });
                          }}
                        />
                        <label className="form-check-label" htmlFor="artworkMerchandisingNo">
                          No
                        </label>
                      </div>
                    </div>
                    {formError.merchandising && <p className="text-center error">Please choose a merchandising right </p>}
                    </fieldset>
                  </div>
                </div>
                )}

                {/* ------ Rights duration ------  */}
                {!agent && !antixx && (
                <div className="row mb-2 mt-2">
                  <div className="col">Rights duration</div>
                  <div className="col ">
                    <select className="form-select custom-select" aria-label="Default select" defaultValue="70" onChange={(e) => handleChange('rightsDuration', e)}>
                      {[...Array(70).keys()].map((i) => (
                        <option value={i + 1} key={i} /* selected={i === 69 ? '"selected"':''} */>
                          {i + 1} {i === 0 ? 'year' : 'years'}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                )}
                
                {/* ------ Price ------  */}


                {/* ------ Supply Number ------  */}
                {!agent && !antixx && (
                <div className="row">
                  <div className="col">
                    <fieldset className="nftInput row">
                      <div className="col-3">
                        <legend className="h6">Supply number</legend>
                      </div>
                      <div className="col">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="supply"
                            id="unique"
                            value={nft.copy.unique}
                            onClick={(e) => {
                              setNft({ ...nft, copy: { ...initialCopies, unique: true }, supplyNumber: 1 });
                              SetFormError({ ...formError, supplyNumber: false });
                            }}
                          />
                          <label className="form-check-label" htmlFor="unique">
                            Unique NFT
                          </label>
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="supply"
                            id="numbered"
                            onClick={(e) => setNft({ ...nft, supplyNumber: null, copy: { ...initialCopies, numbered: true } })}
                          />
                          <label className="form-check-label" htmlFor="numbered">
                            Original numbered NFT
                          </label>
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="supply"
                            id="limited"
                            onClick={(e) => setNft({ ...nft, supplyNumber: null, copy: { ...initialCopies, limited: true } })}
                          />
                          <label className="form-check-label" htmlFor="limited">
                            NFT in limited series
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                )}

                {!agent && !antixx && (
                <div className="row">
                  {nft.copy.numbered && (
                    <div className="offset-6 col-2">
                      <input
                        className="form-control nftInput"
                        id="floatingSupplyNumber"
                        placeholder="2-30"
                        aria-describedby="supply number"
                        defaultValue="2"
                        type="number"
                        min="2"
                        max="30"
                        onChange={(e) => {
                          handleChange('supplyNumber', e);
                        }}
                      />
                      <label htmlFor="floatingSupplyNumber">2-30</label>
                    </div>
                  )}
                  {nft.copy.limited && (
                    <div className="offset-9 col-2">
                      <input
                        className="form-control nftInput"
                        id="floatingSupplyNumber"
                        placeholder="31-150"
                        aria-describedby="supply number"
                        defaultValue="31"
                        type="number"
                        min="31"
                        max="150"
                        onChange={(e) => handleChange('supplyNumber', e)}
                      />
                      <label htmlFor="floatingSupplyNumber">31-150</label>
                    </div>
                  )}
                  
                  {/* ------ Exclusivity ------  */}
                  {nft.copy.unique && (
                    <fieldset className="nftInput">
                      <div className="row">
                        <div className="col-6">
                          <legend className="h6">Exclusive licence</legend>
                        </div>
                        <div className="col-3">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="artworkExclu"
                              value={nft.exclusive}
                              id="artworkExcluYes"
                              onChange={(e) => {
                                setNft({ ...nft, exclusive: true });
                                SetFormError({ ...formError, exclusive: false });
                              }}
                            />
                            <label className="form-check-label" htmlFor="artworkExcluYes">
                              Yes
                            </label>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="artworkExclu"
                              id="artworkExcluNo"
                              value={nft.exclusive}
                              onChange={(e) => {
                                setNft({ ...nft, exclusive: false });
                                SetFormError({ ...formError, exclusive: false });
                              }}
                            />
                            <label className="form-check-label" htmlFor="artworkExcluNo">
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                      {formError.exclusive && <p className="text-center error">Please choose exclusivity </p>}
                    </fieldset>
                  )}
                  {formError.supplyNumber && <p className="text-center error">Incorrect supply number </p>}
                </div>
                )}

                {/* ------ non-reissuance guarantee ------  */}
                {!agent && !antixx && (
                <fieldset className="nftInput">
                  <div className="row">
                    <div className="col-6">
                      <legend className="h6">NFT non-reissuance guarantee</legend>
                    </div>
                    <div className="col-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="artworkReissue"
                          value={nft.noReissue}
                          id="artworkReissueYes"
                          onChange={(e) => {
                            setNft({ ...nft, noReissue: true });
                            SetFormError({ ...formError, noReissue: false });
                          }}
                        />
                        <label className="form-check-label" htmlFor="artworkReissueYes">
                          Yes
                        </label>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="artworkReissue"
                          id="artworkReissueNo"
                          value={nft.noReissue}
                          onChange={(e) => {
                            setNft({ ...nft, noReissue: false });
                            SetFormError({ ...formError, noReissue: false });
                          }}
                        />
                        <label className="form-check-label" htmlFor="artworkReissueNo">
                          No
                        </label>
                      </div>
                    </div>
                    {formError.noReissue && <p className="text-center error">Please choose a guarantee </p>}
                  </div>
                </fieldset>
                )}

                {/* ------ Resale Right ------  */}
                {!agent && !antixx && (
                <fieldset className="nftInput">
                  <div className="row">
                    <div className="col-6">
                      <legend className="h6">Resale right</legend>
                    </div>
                    <div className="col-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="artworkResale"
                          value={nft.resale}
                          id="artworkResaleYes"
                          onChange={(e) => {
                            setNft({ ...nft, resale: true });
                            SetFormError({ ...formError, resale: false });
                          }}
                        />
                        <label className="form-check-label" htmlFor="artworkResaleYes">
                          Yes
                        </label>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="artworkResale"
                          id="artworkResaleNo"
                          value={nft.resale}
                          onChange={(e) => {
                            setNft({ ...nft, resale: false });
                            SetFormError({ ...formError, resale: false });
                          }}
                        />
                        <label className="form-check-label" htmlFor="artworkResaleNo">
                          No
                        </label>
                      </div>
                    </div>
                    {formError.resale && <p className="text-center error">Please specify if there is a resale right</p>}
                  </div>
                </fieldset>
                )}
                {/* ------ Resale Percentage ------  */}
                {nft.resale && (
                  <div className="row mb-2 mt-4">
                    <div className="col form-inline"><div>Resale percentage for the author</div></div>
                    <div className="col ">
                      {!agent && (
                      <select className="form-select custom-select" aria-label="Default select" onChange={(e) => {
                        setResaleRights(e.target.value);
                        handleChange('resaleValue', e);
                        }}>
                        {[...Array(10).keys()].map((i) => (
                          <option value={i + 1} key={i}>{i + 1}%</option>
                        ))}
                      </select>)}
                      {agent && (
                      <select className="form-select custom-select" aria-label="Default select" defaultValue="10" disabled onChange={(e) => {
                        setResaleRights(e.target.value);
                        handleChange('resaleValue', e);
                        }}>
                        {[...Array(10).keys()].map((i) => (
                          <option value={i + 1} key={i}>{i + 1}%</option>
                        ))}
                      </select>)}
                    </div>
                  </div>
                )}

                {/* ------ Description ------  */}
                <div className="form-floating mt-4">
                  <textarea
                    className="form-control nftInput desc"
                    id="floatingDescription"
                    placeholder="Description"
                    rows="2"
                    value={nft.description}
                    onChange={(e) => handleChange('description', e)}
                  ></textarea>
                  <label htmlFor="floatingDescription">Description</label>
                  {formError.description && <p className="text-center error">A description is required </p>}
                </div>
                <div className="text-center submit-infos">
                  {loader ? (
                    <div className="spinner-border " role="status"></div>
                  ) : (
                    <button type="submit" className="btn btn-primary" style={{ fontSize: '1em' }}>
                      {!antixx ? "Submit":"Mint"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default Create;
